module.exports = __webpack_public_path__ + "img/Ronald Bolton.fd6d6548.jpg";